import React from 'react'
import PropTypes from 'prop-types'

// this component is used to expose links as anchors in the html.
// making links visible for crawlers helps to improve the SEO score.

const DummyAnchorTag = (props) => {
  return (
    <a href={props.url} onClick={(e) => {e.preventDefault()}} tabIndex={props.tabIndex || 0}>
      {props.children}
    </a>
  )
}

DummyAnchorTag.propTypes = {
  url: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired
}

export default DummyAnchorTag
